import '/builds/gitlab/gitlab-ee/app/assets/javascripts/pages/groups/show/index.js?vue3';
import initGroupAnalytics from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/analytics/group_analytics/group_analytics_bundle.js?vue3';
import { shouldQrtlyReconciliationMount } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/billings/qrtly_reconciliation/index.js?vue3';
import initVueAlerts from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_alerts.js?vue3';
import initTierBadgeTrigger from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/groups/init_tier_badge_trigger.js?vue3';

initGroupAnalytics();
initVueAlerts();
shouldQrtlyReconciliationMount();
initTierBadgeTrigger();
